module.exports = __webpack_public_path__ + "img/scatter_freespin.64f8fddb.png";